import { useMemo, useState } from 'react';
import { Dialog, useMediaQuery, IconButton } from '@mui/material';
import { Close, KeyboardBackspace } from '@mui/icons-material';
import ModalSlider from '../../ModalSlider';
import Followers from './Followers';
import LinkedinModalContent from '../ShareModals/LinkedinModalContent';
import CopyModalContent from '../ShareModals/CopyModalContent';
import EmailModalContent from '../ShareModals/EmailModalContent';

const useStyles = ({ isXS }) => ({
  dialogContainer: {
    padding: isXS ? '0px' : '10px',
  },
  dialog: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    justifyContent: 'center',
    width: isXS ? 'auto' : '600px',
    height: 'auto',
    alignItems: 'center',
    background: '#FFFFFF',
    borderRadius: isXS ? '0px' : '15px',
    paddingTop: isXS ? '24px' : '24px',
    paddingBottom: isXS ? '0px' : '30px',
  },
});

export default function FollowersModalSlide({ open, setIsOpen }) {
  const [activeStep, setActiveStep] = useState(0);
  const [secondStep, setSecondStep] = useState('linkedin');

  function handleClose() {
    if (blockClosePopup) {
      return;
    }
    setIsOpen(false);
    setActiveStep(0);
  }
  const [blockClosePopup, setBlockClosePopup] = useState(false);
  const SecondStepModals = {
    linkedin: (
      <LinkedinModalContent
        handleClose={handleClose}
        isLoading={blockClosePopup}
        setIsLoading={setBlockClosePopup}
        forceSnackbar
      />
    ),
    facebook: <CopyModalContent modalType="facebook" forceSnackbar />,
    x: <CopyModalContent modalType="x" forceSnackbar />,
    code: <CopyModalContent modalType="code" forceSnackbar />,
    email: (
      <EmailModalContent
        setOpen={setIsOpen}
        isLoading={blockClosePopup}
        setIsLoading={setBlockClosePopup}
        forceSnackbar
      />
    ),
  };

  const steps = useMemo(() => {
    return [
      <Followers
        setNextStepType={(type) => {
          setSecondStep(type);
          setActiveStep(1);
        }}
      />,
      SecondStepModals[secondStep],
    ];
  }, [secondStep]);

  const isXS = useMediaQuery((theme) => theme.breakpoints.down([680]));
  const classes = useStyles({ isXS });

  return (
    <Dialog
      open={open}
      sx={classes.dialogContainer}
      fullScreen={isXS}
      PaperProps={{ sx: { borderRadius: { xxs: 0, sm: '10px' } } }}
      onClose={handleClose}
    >
      <div style={classes.dialog}>
        {isXS && (
          <IconButton
            size="small"
            onClick={handleClose}
            sx={{ position: 'absolute', top: 0, right: 0 }}
          >
            <Close />
          </IconButton>
        )}
        {activeStep > 0 && (
          <IconButton
            size="small"
            onClick={() => setActiveStep(0)}
            sx={{ position: 'absolute', top: { xxs: 0, xs: 32 }, left: 20 }}
          >
            <KeyboardBackspace />
          </IconButton>
        )}
        <ModalSlider
          steps={steps}
          activeStep={activeStep}
          width={{
            xxs: 'auto',
            xs: '500px',
          }}
        />
      </div>
    </Dialog>
  );
}
